import { FC } from 'react'

import { Divider } from '@cash-me/react-components'

import { Grid, Col } from 'components/grid'

import { Legal } from './legal'
import * as S from './styles'
import { Warning } from './warning'

const Footer: FC = () => (
  <S.Wrapper>
    <Grid col={{ phone: 1, tablet: 1, desktop: 12 }}>
      <Col col={{ desktop: 10 }} start={{ desktop: 2 }}>
        <Warning />
        <Divider css={{ margin: '1.5rem 0', backgroundColor: '#555B66' }} />
        <Legal />
      </Col>
    </Grid>
  </S.Wrapper>
)

export default Footer
